
import { initSentry } from "./sentry";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import "antd/dist/antd.min.css";
import "./index.css";
import "./antd.css";
import App from "./App";
import { store } from "./redux/configureStore";

initSentry();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
